module.exports = __webpack_public_path__ + "media/images/flags/32/Guyana-f60a981eba456aface4eff0001f20e56.png";